<template>
  <ModalConfirmAction
    title="Excluir janela"
    message="Você tem certeza que deseja remover esta janela de atualização?"
    confirmText="Excluir"
    :loading="loading"
    @confirm="deleteConfig"
  >
    <template #activator="{ on, attrs }">
      <div class="table-action-box table-action-delete" v-bind="attrs" v-on="on">
        <v-icon small>mdi-delete-outline</v-icon>
        <span class="table-action-label">Excluir</span>
      </div>
    </template>
  </ModalConfirmAction>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";
import ModalConfirmAction from "../ModalConfirmAction.vue";

export default {
  name: "ModalRemoverConfiguracaoUpdateEnquetes",
  components: { ModalConfirmAction },
  props: {
    idCategoria: { type: Number, required: true },
    idConfig: { type: Number, required: true },
  },
  data() {
    return { loading: false };
  },
  methods: {
    ...mapActions({
      getCategorias: "enquetes/getCategoriasEnquetes",
    }),
    async deleteConfig() {
      this.loading = true;
      try {
        await apiClient.delete(
          `/enquetes/categorias/${this.idCategoria}/config/${this.idConfig}`
        );
        await this.getCategorias({ page: 1, size: 100 });
        this.$toast.success("Janela removida com sucesso!");
      } catch (error) {
        this.$toast.error("Erro ao remover janela.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
